import React from 'react';

function ProgressBar({ value = 0, color, className = '', height }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className={`progress ${className}`} style={height ? { height } : undefined}>
      <span style={{ width: `${pct}%`, background: color || undefined }} />
    </div>
  );
}

export default ProgressBar;
